var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1654 11.6668V16.6668M11.6654 14.1668H16.6654M4.9987 8.3335H6.66536C7.58584 8.3335 8.33203 7.5873 8.33203 6.66683V5.00016C8.33203 4.07969 7.58584 3.3335 6.66536 3.3335H4.9987C4.07822 3.3335 3.33203 4.07969 3.33203 5.00016V6.66683C3.33203 7.5873 4.07822 8.3335 4.9987 8.3335ZM13.332 8.3335H14.9987C15.9192 8.3335 16.6654 7.5873 16.6654 6.66683V5.00016C16.6654 4.07969 15.9192 3.3335 14.9987 3.3335H13.332C12.4116 3.3335 11.6654 4.07969 11.6654 5.00016V6.66683C11.6654 7.5873 12.4116 8.3335 13.332 8.3335ZM4.9987 16.6668H6.66536C7.58584 16.6668 8.33203 15.9206 8.33203 15.0002V13.3335C8.33203 12.413 7.58584 11.6668 6.66536 11.6668H4.9987C4.07822 11.6668 3.33203 12.413 3.33203 13.3335V15.0002C3.33203 15.9206 4.07822 16.6668 4.9987 16.6668Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a64c3e7304fc4e523636ba08aca34cda.svg";
export { ForwardRef as ReactComponent };